export const ANALYTICS_EVENT = Object.freeze({
  GRADES_EXPORT_CSV: 'grades_export_csv',
  GRADES_SAVE_CHANGES: 'grades_save_changes',
  GUEST_ENTER: 'guest_enter',
  GUEST_REQUEST_ACCOUNT: 'guest_request_account',
  VIEW_UNIT_FILES: 'view_unit_files_action',
  VIEW_CLASS_CODE: 'view_class_code_action',
  VIEW_MY_NOTES: 'view_my_notes_action',
  CREATE_DISCUSSION: 'create_discussion_action',
  DELETE_DISCUSSION: 'delete_discussion_action',
  CLOSE_DISCUSSION: 'close_discussion_action',
  VIEW_DISCUSSION: 'view_discussion_action',
  POST_DISCUSSION_MESSAGE: 'post_discussion_message_action',
  EDIT_DISCUSSION_MESSAGE: 'edit_discussion_message_action',
  REPLY_DISCUSSION_MESSAGE: 'reply_discussion_message_action',
  DELETE_DISCUSSION_MESSAGE: 'delete_discussion_message_action',
  LIKE_DISCUSSION_MESSAGE: 'like_discussion_message_action',
  CATALOG_MY_UNITS: 'catalog_my_units_action',
  CATALOG_HELP: 'catalog_help_action',
  CATALOG_SEARCH: 'catalog_search_action',
  CATALOG_VIEW_TOGGLE: 'catalog_view_toggle_action',
  CATALOG_FILTER_MODE: 'catalog_filter_mode_action',
  CATALOG_PREVIEW: 'catalog_preview_action'
});

export const ANALYTICS_CONTEXT = Object.freeze({
  BOOK_CREATE: 'book_create',
  BOOK_IMPORT: 'book_import',
  BOOK_COPY: 'book_copy',
  BOOK_DELETE: 'book_delete',
  BOOK_ASSIGN: 'book_assign',
  BOOK_SHOW: 'book_show',
  BOOK_HIDE: 'book_hide',
  UNIT_CREATE: 'unit_create',
  UNIT_IMPORT: 'import_unit',
  UNIT_DELETE: 'unit_delete',
  UNIT_ASSIGN: 'unit_assign',
  UNIT_SHOW: 'unit_show',
  UNIT_HIDE: 'unit_hide',
  LESSON_IMPORT: 'import_lesson',
  LESSON_DELETE: 'lesson_delete',
  LESSON_ASSIGN: 'lesson_assign',
  LESSON_SHOW: 'lesson_show',
  LESSON_HIDE: 'lesson_hide',
  LESSON_CLONE_CARD_BUTTON: 'card_button',
  LESSON_CLONE_POPUP_CATALOGUE: 'popup_catalogue',
  EMPTY_LESSON_CREATE: 'empty_lesson_create',
  FILE_UPLOAD: 'file_upload',
  LINK_ADD: 'link_add',
  AUTOEXEC_ADD: 'autoexec_add',
  SCORM_ADD: 'scorm_add',
  CLASSROOM_CREATE: 'classroom_create',
  CLASSROOM_ARCHIVE: 'classroom_archive',
  GROUP_CREATE: 'group_create',
  NEAE_PANEL: 'neae_panel',
  GRADES_EXPORT_BUTTON: 'gradebook_export_button',
  GRADES_SAVE_BUTTON: 'gradebook_save_button',
  // Mobile: assessable switch of the gradebook student sheet
  GRADES_MOBILE_SWITCH: 'gradebook_mobile_switch',
  GUEST_ENTER_BUTTON: 'guest_enter_button',
  GUEST_REQUEST_ACCOUNT_BUTTON: 'guest_request_account_button',
  UNIT_FILES_PREVIEW: 'unit_files_preview',
  CLASS_CODE_POPUP: 'class_code_popup',
  // Mobile: class code sheet (home card) and class header ⋮ sheet
  CLASS_CODE_SHEET: 'class_code_sheet',
  CLASS_MORE_SHEET: 'class_more_sheet',
  MY_NOTES: 'my_notes',
  // Mobile: from the book and unit option sheets
  MY_NOTES_SHEET: 'my_notes_sheet',
  UNIT_FILES_SHEET: 'unit_files_sheet',
  DISCUSSION_DRAWER: 'discussion_drawer',
  DISCUSSION_REMOVE_REVEAL: 'discussion_remove_reveal',
  DISCUSSION_CLOSE_REVEAL: 'discussion_close_reveal',
  DISCUSSION_DETAIL: 'discussion_detail',
  DISCUSSION_MESSAGE_LIST: 'discussion_message_list'
});
